import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyTheme, DEFAULT_THEME } from './themes';

applyTheme(DEFAULT_THEME);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
    showBootstrapError(err);
  });

function showBootstrapError(err: unknown) {
  const root = document.querySelector('app-root');
  if (!root) {
    return;
  }
  root.innerHTML = `
    <main style="display:flex; height: 100vh; justify-content: center; align-items: center; padding: 0 16px; text-align: center; color: #374151">
      <div>
        Nie udało się załadować strony płatności.<br />
        Odśwież stronę lub otwórz link w innej przeglądarce.<br />
        Jeśli problem się powtarza, napisz do nas: <a href="mailto:pomoc@billtech.pl">pomoc@billtech.pl</a>
        <p id="bootstrap-error-code" style="margin-top: 16px; font-size: 12px; color: #6b7280"></p>
      </div>
    </main>`;
  root.querySelector('#bootstrap-error-code').textContent = `Kod błędu: ${bootstrapErrorCode(err)}`;
}

function bootstrapErrorCode(err: unknown): string {
  const name = err instanceof Error ? err.name : 'UnknownError';
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, '0');
  const time = `${pad(now.getDate())}.${pad(now.getMonth() + 1)} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
  return `${name} · ${time}`;
}
